import React from 'react';
import { Logo } from '../common/Logo';

interface LoginScreenProps {
  onLogin: () => Promise<void>;
}

export const LoginScreen: React.FC<LoginScreenProps> = ({ onLogin }) => {
  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center bg-slate-50 p-4 py-6 md:py-4 font-sans">
      {/* Animated Background Blobs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] bg-gradient-to-br from-blue-400 to-purple-500 rounded-full blur-3xl opacity-40 animate-float-slow mix-blend-multiply"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] bg-gradient-to-br from-pink-400 to-orange-400 rounded-full blur-3xl opacity-40 animate-float-medium mix-blend-multiply"></div>
        <div className="absolute top-[30%] left-[20%] w-[50%] h-[50%] bg-gradient-to-br from-teal-300 to-cyan-400 rounded-full blur-3xl opacity-30 animate-float-fast mix-blend-multiply"></div>
      </div>

      {/* Login Card */}
      <div className="relative z-10 w-full max-w-md">
        <div className="glass-card p-6 md:p-10 rounded-3xl shadow-2xl animate-fade-in">
          {/* Logo */}
          <div className="flex justify-center mb-4 md:mb-8">
            <div className="relative group">
              <div className="absolute inset-0 bg-indigo-500/30 rounded-full blur-2xl animate-pulse-slow"></div>
              <Logo className="w-20 h-20 md:w-24 md:h-24 text-indigo-600/90 drop-shadow-2xl relative z-10 transition-transform group-hover:scale-110 duration-300" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-5xl font-extrabold text-center mb-2 md:mb-3 tracking-tight">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">
              TechCoop Sports
            </span>
          </h1>
          <p className="text-slate-600 text-center mb-6 md:mb-10 text-sm md:text-base font-medium">
            Nền tảng thi đấu nội bộ
          </p>



          {/* Login Button */}
          <button
            onClick={onLogin}
            className="w-full flex items-center justify-center gap-3 bg-white border-2 border-slate-200 hover:border-indigo-300 p-3 md:p-4 rounded-2xl hover:bg-slate-50 transition-all font-bold text-slate-700 shadow-lg hover:shadow-xl group text-sm md:text-base"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="w-5 h-5 md:w-6 md:h-6" alt="Google" />
            <span className="group-hover:text-indigo-600 transition-colors">Đăng nhập bằng Google</span>
          </button>

          <p className="text-xs text-slate-400 text-center mt-4 md:mt-6">
            Dành cho thành viên TechCoop
          </p>
        </div>
      </div>
    </div>
  );
};
